import { cva, RecipeVariant, type RecipeVariantProps } from 'styled-system/css';

const radioButton = cva({
  base: {
    appearance: 'none',
    width: '16px',
    height: '16px',
    border: '2px solid',
    borderRadius: '50%',
    position: 'relative',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease-in-out',
  },
  variants: {
    color: {
      primary: {
        borderColor: 'black-4',
      },
    },

    checked: {
      true: {
        '&::before': {
          content: '""',
          display: 'block',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: 'purple-3',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        },
        borderColor: 'purple-3',
      },
      false: {},
    },
    disabled: {
      true: {
        borderColor: 'gray-1',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      checked: true,
      css: {
        borderColor: 'purple-3',
        '&::before': {
          backgroundColor: 'purple-3',
        },
      },
    },
    {
      checked: true,
      disabled: true,
      css: {
        borderColor: 'gray-1',
        '&::before': {
          backgroundColor: 'gray-1',
        },
      },
    },
    {
      checked: false,
      disabled: true,
      css: {
        borderColor: 'gray-1',
      },
    },
  ],
  defaultVariants: {
    color: 'primary',
    checked: false,
  },
});

export { radioButton };

export type RadioButtonRecipeVariants = RecipeVariantProps<typeof radioButton>;
export type RadioButtonVariants = RecipeVariant<typeof radioButton>;
